module.exports = __webpack_public_path__ + "static/media/file-upload.9d107cf1.svg";